import { Unsubscribe } from "@mui/icons-material";
import { FC } from "react";

import { greyMui, redMui } from "@ryde/theme";

import { HeaderLine2SupplierSendStatusIconStyled } from "./ride-header.styled";
import { TRideSupplierSendStatus } from "./ride-supplier-header.models";
import { shouldShowRideSupplierSendStatusIcon } from "./ride-supplier-header.utils";

interface IRideSupplierSendStatusIconProps {
  status: TRideSupplierSendStatus;
}

export const RideSupplierSendStatusIcon: FC<
  IRideSupplierSendStatusIconProps
> = ({ status }) => {
  if (!shouldShowRideSupplierSendStatusIcon(status)) {
    return null;
  }

  return (
    <HeaderLine2SupplierSendStatusIconStyled
      style={{
        color: status === "allowedByPermission" ? greyMui._400 : redMui._700,
      }}
    >
      <Unsubscribe fontSize="small" />
    </HeaderLine2SupplierSendStatusIconStyled>
  );
};
